/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Warm_Hawk_RollInputs */

const en_glad_warm_hawk_roll = /** @type {(inputs: Glad_Warm_Hawk_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete group`)
};

const de_glad_warm_hawk_roll = /** @type {(inputs: Glad_Warm_Hawk_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe löschen`)
};

/**
* | output |
* | --- |
* | "Delete group" |
*
* @param {Glad_Warm_Hawk_RollInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const glad_warm_hawk_roll = /** @type {((inputs?: Glad_Warm_Hawk_RollInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Warm_Hawk_RollInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_glad_warm_hawk_roll(inputs)
	return de_glad_warm_hawk_roll(inputs)
});